export const styles = {
    crPoliciesHeader: {
        py: 4,
    },
    crPolicies: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    contentHeaderWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '32px',
    },
    contentBodyWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        boxShadow: ' 0 0 9px #9c9c9c61',
    },
};
